import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
import requestIdleCallback, { cancelIdleCallback } from 'ric-shim';
import { obx, computed, makeObservable } from '@alilc/lowcode-editor-core';
import { uniqueId } from '@alilc/lowcode-utils';
export var OffsetObserver = (_class = /*#__PURE__*/function () {
  function OffsetObserver(nodeInstance) {
    var _this = this;
    this.nodeInstance = nodeInstance;
    this.id = uniqueId('oobx');
    this.lastOffsetLeft = void 0;
    this.lastOffsetTop = void 0;
    this.lastOffsetHeight = void 0;
    this.lastOffsetWidth = void 0;
    _initializerDefineProperty(this, "_height", _descriptor, this);
    _initializerDefineProperty(this, "_width", _descriptor2, this);
    _initializerDefineProperty(this, "_left", _descriptor3, this);
    _initializerDefineProperty(this, "_top", _descriptor4, this);
    _initializerDefineProperty(this, "_right", _descriptor5, this);
    _initializerDefineProperty(this, "_bottom", _descriptor6, this);
    _initializerDefineProperty(this, "hasOffset", _descriptor7, this);
    this.pid = void 0;
    this.viewport = void 0;
    this.isRoot = void 0;
    this.node = void 0;
    this.compute = void 0;
    var node = nodeInstance.node,
      instance = nodeInstance.instance;
    this.node = node;
    var doc = node.document;
    var host = doc === null || doc === void 0 ? void 0 : doc.simulator;
    var focusNode = doc === null || doc === void 0 ? void 0 : doc.focusNode;
    this.isRoot = node.contains(focusNode);
    this.viewport = host === null || host === void 0 ? void 0 : host.viewport;
    makeObservable(this);
    if (this.isRoot) {
      this.hasOffset = true;
      return;
    }
    if (!instance) {
      return;
    }
    var pid;
    var compute = function compute() {
      if (pid !== _this.pid) {
        return;
      }
      var rect = host.computeComponentInstanceRect(instance, node.componentMeta.rootSelector);
      if (!rect) {
        _this.hasOffset = false;
      } else if (!_this.viewport.scrolling || !_this.hasOffset) {
        _this._height = rect.height;
        _this._width = rect.width;
        _this._left = rect.left;
        _this._top = rect.top;
        _this._right = rect.right;
        _this._bottom = rect.bottom;
        _this.hasOffset = true;
      }
      _this.pid = requestIdleCallback(compute);
      pid = _this.pid;
    };
    this.compute = compute;

    // try first
    compute();
    // try second, ensure the dom mounted
    this.pid = requestIdleCallback(compute);
    pid = this.pid;
  }
  var _proto = OffsetObserver.prototype;
  _proto.purge = function purge() {
    if (this.pid) {
      cancelIdleCallback(this.pid);
    }
    this.pid = undefined;
  };
  _proto.isPurged = function isPurged() {
    return this.pid == null;
  };
  _createClass(OffsetObserver, [{
    key: "height",
    get: function get() {
      return this.isRoot ? this.viewport.height : this._height * this.scale;
    }
  }, {
    key: "width",
    get: function get() {
      return this.isRoot ? this.viewport.width : this._width * this.scale;
    }
  }, {
    key: "top",
    get: function get() {
      return this.isRoot ? 0 : this._top * this.scale;
    }
  }, {
    key: "left",
    get: function get() {
      return this.isRoot ? 0 : this._left * this.scale;
    }
  }, {
    key: "bottom",
    get: function get() {
      return this.isRoot ? this.viewport.height : this._bottom * this.scale;
    }
  }, {
    key: "right",
    get: function get() {
      return this.isRoot ? this.viewport.width : this._right * this.scale;
    }
  }, {
    key: "offsetLeft",
    get: function get() {
      if (this.isRoot) {
        return this.viewport.scrollX * this.scale;
      }
      if (!this.viewport.scrolling || this.lastOffsetLeft == null) {
        this.lastOffsetLeft = this.left + this.viewport.scrollX * this.scale;
      }
      return this.lastOffsetLeft;
    }
  }, {
    key: "offsetTop",
    get: function get() {
      if (this.isRoot) {
        return this.viewport.scrollY * this.scale;
      }
      if (!this.viewport.scrolling || this.lastOffsetTop == null) {
        this.lastOffsetTop = this.top + this.viewport.scrollY * this.scale;
      }
      return this.lastOffsetTop;
    }
  }, {
    key: "offsetHeight",
    get: function get() {
      if (!this.viewport.scrolling || this.lastOffsetHeight == null) {
        this.lastOffsetHeight = this.isRoot ? this.viewport.height : this.height;
      }
      return this.lastOffsetHeight;
    }
  }, {
    key: "offsetWidth",
    get: function get() {
      if (!this.viewport.scrolling || this.lastOffsetWidth == null) {
        this.lastOffsetWidth = this.isRoot ? this.viewport.width : this.width;
      }
      return this.lastOffsetWidth;
    }
  }, {
    key: "scale",
    get: function get() {
      return this.viewport.scale;
    }
  }]);
  return OffsetObserver;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_height", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_width", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_left", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_top", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_right", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_bottom", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "height", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "height"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "width", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "width"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "top", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "top"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "left", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "left"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bottom", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bottom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "right", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "right"), _class.prototype), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasOffset", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "offsetLeft", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "offsetLeft"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "offsetTop", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "offsetTop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "offsetHeight", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "offsetHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "offsetWidth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "offsetWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scale", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "scale"), _class.prototype)), _class);
export function createOffsetObserver(nodeInstance) {
  if (!nodeInstance.instance) {
    return null;
  }
  return new OffsetObserver(nodeInstance);
}